function Description({ value, handleValue }) {
   return (
      <div className="group">
         <label htmlFor="description">Description</label>
         <textarea
            id="description"
            rows={3}
            autoComplete="off"
            placeholder="A short bio or professional summary…"
            value={value ?? ''}
            onChange={e => handleValue(e.target.value, 'description')}
         />
      </div>
   )
}

export default Description
